import { render } from "./EventListV2.vue?vue&type=template&id=a881f464&scoped=true"
import script from "./EventListV2.vue?vue&type=script&lang=js"
export * from "./EventListV2.vue?vue&type=script&lang=js"

import "./EventListV2.vue?vue&type=style&index=0&id=a881f464&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a881f464"]])

export default __exports__